"use client"
import React, { useState, useRef, useEffect } from 'react';
import './IntermediateHero.css';
import defaultImage from '../../assets/intermedio_4.jpg'; // Optional default image
import Swal from 'sweetalert2';
import { create_client } from '../services_back/services';
import ModalTratDatos from './modal'; // Asegúrate de importar el modal correctamente
import { Modal, Button } from 'react-bootstrap';

const IntermediateHero = ({ image }) => {
  const [showModal, setShowModal] = useState(false);
  const [showDataModal, setShowDataModal] = useState(false);
  const [dataChecked, setDataChecked] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true); // Estado para el mensaje flotante
  const [isSubmitting, setIsSubmitting] = useState(false); // Estado para controlar el envío
  const [contactData, setContactData] = useState({
    name: '',
    vat: '',
    email: '',
  });

  const intermediateLayerRef = useRef(null);
  const tooltipRef = useRef(null);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (intermediateLayerRef.current) {
      if (typeof window !== 'undefined') {
        window.intermediateLayerRef = intermediateLayerRef;
      }
    }

    // Ocultar el mensaje flotante después de 6 segundos
    const timer = setTimeout(() => {
      setShowTooltip(false);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!dataChecked) {
      Swal.fire({
        title: 'Atención',
        text: 'Por favor, haga clic en "Acepto el tratamiento de datos" para leer y aceptar los términos.',
        icon: 'info',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: '#d7e3df',
        iconColor: '#07593B'
      });
      return;
    }

    // Evitar múltiples envíos
    if (isSubmitting) return;
    setIsSubmitting(true);

    const data = {
      name: contactData.name,
      email: contactData.email,
      vat: contactData.vat,
    };

    console.log("Datos formateados para enviar", data);

    try {
      await create_client(data, async (flag, res) => {
        console.log("Respuesta del servicio crear cliente", flag, res);
        setIsSubmitting(false);
        
        if (flag) {
          Swal.fire({
            title: 'Datos enviados exitosamente',
            text: 'Gracias por registrarte',
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            background: '#d7e3df',
            iconColor: '#07593B'
          }).then(() => {
            setShowModal(false);
            // Limpiar el formulario después de un envío exitoso
            setContactData({
              name: '',
              vat: '',
              email: '',
              phone: '',
            });
            setDataChecked(false);
          });
        } else {
          Swal.fire({
            title: 'No se realizó el registro',
            text: res?.message || 'Verifique su conexión a internet y realice el registro nuevamente',
            icon: 'warning',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            background: '#d7e3df',
            iconColor: '#07593B'
          });
        }
      });
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error en el proceso de registro:", error);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error inesperado. Por favor, inténtelo más tarde.',
        icon: 'error',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: '#d7e3df',
        iconColor: '#07593B'
      });
    }
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactData(prevState => ({ ...prevState, [name]: value }));
  };

  return (
    <>
      <div 
        className="intermediate-layer" 
        ref={intermediateLayerRef}
        style={{ 
          backgroundImage: `url(${image || defaultImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="intermediate-content">
          <div className="text-container">
            <div className="text-overlay">
              <h2>Regístrate con nosotros</h2>
              <h3>Y gánate un 5% de descuento en cualquiera de nuestros tratamientos</h3>
              <button className="discover-btn" onClick={openModal}>Registrarse</button>
            </div>
          </div>
        </div>
      </div>
      
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Formulario de Contacto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Nombre Completo"
                required
                value={contactData.name}
                onChange={handleContactChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="vat"
                placeholder="Documento"
                required
                value={contactData.vat}
                onChange={handleContactChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Correo"
                required
                value={contactData.email}
                onChange={handleContactChange}
                className="form-control"
              />
            </div>

            <div className="form-group position-relative">
              <input
                type="checkbox"
                checked={dataChecked}
                onChange={() => setDataChecked(!dataChecked)}
              />
              <span className="link" ref={tooltipRef} onClick={() => setShowDataModal(true)}>
                Acepto el tratamiento de datos
              </span>
              {showTooltip && (
                <div className="tooltip-message" style={{ top: tooltipRef.current?.offsetTop - 30, left: tooltipRef.current?.offsetLeft }}>
                  Dar click al texto "Acepto el tratamiento de datos" para leer y aceptar la información.
                </div>
              )}
            </div>
            <Button 
              type="submit" 
              className="btn btn-primary" 
              disabled={!dataChecked || isSubmitting}
            >
              {isSubmitting ? 'Enviando...' : 'Enviar'}
            </Button>
          </form>
        </Modal.Body>
      </Modal>

      <ModalTratDatos showDataModal={showDataModal} setShowDataModal={setShowDataModal} />
    </>
  );
};

export default IntermediateHero;